import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=1d54fe2e&"
import script from "./SearchResults.vue?vue&type=script&lang=js&"
export * from "./SearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d54fe2e')) {
      api.createRecord('1d54fe2e', component.options)
    } else {
      api.reload('1d54fe2e', component.options)
    }
    module.hot.accept("./SearchResults.vue?vue&type=template&id=1d54fe2e&", function () {
      api.rerender('1d54fe2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SearchResults.vue"
export default component.exports